import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<svg width="100%" height="100%" viewBox="0 0 406 406" xmlns="http://www.w3.org/2000/svg">
                  <g transform="matrix(-1,0,0,1,405.332,0)">
                    <path d="M0,202.668C0,314.598 90.738,405.332 202.668,405.332C314.598,405.332 405.332,314.598 405.332,202.668C405.332,90.738 314.598,0 202.668,0C90.738,0 0,90.738 0,202.668ZM179.094,118.398L264.426,193.066C267.203,195.484 268.801,198.984 268.801,202.668C268.801,206.348 267.203,209.852 264.426,212.266L179.094,286.934C173.793,291.586 165.719,291.062 161.066,285.762C156.414,280.457 156.938,272.387 162.238,267.734L236.586,202.668L162.238,137.602C156.938,132.945 156.414,124.875 161.066,119.574C165.719,114.27 173.793,113.746 179.094,118.398Z"/>
                  </g>
                </svg>`,
      }}
    />
  );
}
